// Custom JavaScript

function updateCartTerms(checked) {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: "attributes[Terms]=" + (checked ? "Yes" : "no")
    });
}
if(document.getElementById("CartTerms")){
	document.getElementById("CartTerms").addEventListener("change", function() {
		updateCartTerms(this.checked);
	});
}
if(document.getElementById("CartTermsDrawer")){
	document.getElementById("CartTermsDrawer").addEventListener("change", function() {
		updateCartTerms(this.checked);
	});
}

function addCheckoutEvent() {
    document.querySelectorAll("[name='checkout']").forEach(function(checkoutButton) {
        checkoutButton.addEventListener("click", function(e) {
            var error = false;
            document.querySelectorAll(".form-field--checkbox").forEach(function(field) {
                var checkbox = field.querySelector('input[type=checkbox]');
                if (checkbox && checkbox.classList.contains("required") && !checkbox.checked) {
                    field.classList.add("error");
                   error = true;
                } else {
                    field.classList.remove("error");
                }
            });
            if (error) {
                e.preventDefault();
            }
        });
    });
}
document.addEventListener("DOMContentLoaded", function() {
    addCheckoutEvent();
	// setTimeout(function(){
	// 	addCheckoutEvent();
	// }, 1000);
});
